var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"justify-center d-block pa-3 pa-md-6 pa-lg-12"},[_c('h1',{staticClass:"display-1 mb-2",domProps:{"innerHTML":_vm._s(_vm.titre)}}),_c('p',{staticClass:"body-1",domProps:{"innerHTML":_vm._s(_vm.message)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }